export type NlbTermsBlock =
  | { type: 'paragraph'; text: string }
  | { type: 'list'; items: string[] };

export type NlbTermsSection = {
  title?: string;
  blocks: NlbTermsBlock[];
};

export const NLB_TERMS_INTRO =
  'Fitur Nominal Lebih Bayar adalah fitur pada Sukanda OneLink yang digunakan untuk mencatat kelebihan pembayaran dari transaksi tertentu yang dilakukan oleh pelanggan B2B melalui metode bank transfer. Dengan menggunakan Sukanda OneLink, Anda dianggap telah membaca, memahami, dan menyetujui syarat dan ketentuan berikut.';

export const NLB_TERMS_IMPORTANT_LEFT = [
  'Tidak dapat dicairkan',
  'Tidak dapat ditambahkan manual',
];

export const NLB_TERMS_IMPORTANT_RIGHT = [
  'Hanya berlaku pada pembayaran bank transfer',
  'Tidak berlaku untuk ToP dan CoD',
];

export const NLB_TERMS_SECTIONS: NlbTermsSection[] = [
  {
    title: 'Apa itu Nominal Lebih Bayar',
    blocks: [
      {
        type: 'paragraph',
        text: 'Nominal Lebih Bayar adalah nilai kelebihan pembayaran yang dicatat secara internal di sistem Sukanda OneLink sebagai alat penyesuaian transaksi.',
      },
      {
        type: 'paragraph',
        text: 'Nominal Lebih Bayar hanya digunakan untuk membantu perhitungan pembayaran pada transaksi berikutnya di Sukanda OneLink, dan bukan merupakan simpanan dana, deposito, dompet elektronik, kredit, pinjaman uang, atau layanan perbankan.',
      },
    ],
  },
  {
    title: 'Siapa yang bisa menggunakan fitur',
    blocks: [
      {
        type: 'paragraph',
        text: 'Fitur Nominal Lebih Bayar hanya berlaku untuk:',
      },
      {
        type: 'list',
        items: [
          'akun pelanggan B2B di Sukanda OneLink; dan transaksi dengan metode pembayaran bank transfer.',
        ],
      },
      {
        type: 'paragraph',
        text: 'Fitur ini tidak berlaku untuk pelanggan dengan metode pembayaran:',
      },
      {
        type: 'list',
        items: ['Term of Payment (ToP); atau', 'Cash on Delivery (CoD).'],
      },
    ],
  },
  {
    title: 'Kapan Nominal Lebih Bayar muncul',
    blocks: [
      {
        type: 'paragraph',
        text: 'Nominal Lebih Bayar hanya dapat timbul apabila semua kondisi berikut terpenuhi:',
      },
      {
        type: 'list',
        items: [
          'transaksi dilakukan melalui Sukanda OneLink;',
          'pembayaran dilakukan menggunakan bank transfer;',
          'terjadi pembatalan pesanan, baik seluruhnya maupun sebagian, dan/atau terjadi perubahan harga yang menyebabkan ada kelebihan pembayaran;',
          'pembayaran tersebut telah diterima dan diverifikasi oleh PT Sukanda Djaya; dan',
          'hasil pemeriksaan internal menunjukkan bahwa memang terdapat kelebihan pembayaran yang sah untuk dicatat.',
        ],
      },
      {
        type: 'paragraph',
        text: 'Nominal Lebih Bayar tidak akan muncul otomatis apabila pembayaran belum diterima, belum diverifikasi, masih dalam sengketa, atau tidak memenuhi ketentuan yang berlaku.',
      },
    ],
  },
  {
    title: 'Nominal Lebih Bayar tidak dapat dicairkan',
    blocks: [
      {
        type: 'paragraph',
        text: 'Nominal Lebih Bayar tidak dapat diuangkan, tidak dapat dicairkan, dan tidak dapat ditarik tunai dalam bentuk apa pun.',
      },
      {
        type: 'paragraph',
        text: 'Nominal Lebih Bayar juga bukan hak untuk meminta pengembalian uang tunai, melainkan hanya hak penggunaan terbatas untuk penyesuaian pembayaran pada transaksi berikutnya di Sukanda OneLink.',
      },
    ],
  },
  {
    title: 'Nominal Lebih Bayar tidak bisa ditambahkan secara sengaja',
    blocks: [
      {
        type: 'paragraph',
        text: 'Nominal Lebih Bayar tidak dapat ditambahkan secara sengaja oleh pelanggan. Artinya, Anda tidak dapat:',
      },
      {
        type: 'list',
        items: [
          'melakukan top up;',
          'melakukan deposit;',
          'menitipkan dana;',
          'mengisi saldo secara manual; atau',
          'sengaja mentransfer dana berlebih untuk membuat Nominal Lebih Bayar.',
        ],
      },
      {
        type: 'paragraph',
        text: 'PT Sukanda Djaya berhak menolak atau tidak mencatat Nominal Lebih Bayar apabila ditemukan indikasi adanya top up terselubung, deposit terselubung, pembayaran tidak wajar, manipulasi, atau penyalahgunaan fitur.',
      },
    ],
  },
  {
    title: 'Fungsi Nominal Lebih Bayar',
    blocks: [
      {
        type: 'paragraph',
        text: 'Nominal Lebih Bayar hanya berfungsi sebagai alat penyesuaian transaksi Sukanda OneLink dari PT Sukanda Djaya.',
      },
      {
        type: 'paragraph',
        text: 'Fitur ini tidak dimaksudkan sebagai layanan penyimpanan dana, fasilitas pembiayaan, alat pembayaran umum, atau produk jasa keuangan dalam bentuk apa pun.',
      },
    ],
  },
  {
    title: 'Cara penggunaan Nominal Lebih Bayar',
    blocks: [
      {
        type: 'paragraph',
        text: 'Nominal Lebih Bayar hanya dapat digunakan untuk pembelanjaan berikutnya melalui Sukanda OneLink PT Sukanda Djaya.',
      },
      {
        type: 'paragraph',
        text: 'Penggunaannya bersifat opsional, sehingga Anda dapat memilih untuk:',
      },
      {
        type: 'list',
        items: [
          'menggunakan seluruh Nominal Lebih Bayar;',
          'menggunakan sebagian Nominal Lebih Bayar; atau',
          'tidak menggunakan Nominal Lebih Bayar pada transaksi tertentu.',
        ],
      },
      {
        type: 'paragraph',
        text: 'Jika nilai Nominal Lebih Bayar tidak mencukupi untuk membayar seluruh tagihan transaksi berikutnya, maka sisa tagihan dapat dibayarkan dengan bank transfer.',
      },
      {
        type: 'paragraph',
        text: 'Nominal Lebih Bayar tidak dapat digunakan:',
      },
      {
        type: 'list',
        items: [
          'di luar Sukanda OneLink;',
          'untuk transaksi dengan pihak selain PT Sukanda Djaya;',
          'sebagai alat pembayaran umum;',
          'untuk transfer antar akun; atau',
          'untuk dijual, dialihkan, dipindahtangankan, dijaminkan, atau digadaikan kepada pihak lain.',
        ],
      },
    ],
  },
  {
    title: 'Estimasi waktu pencatatan',
    blocks: [
      {
        type: 'paragraph',
        text: 'PT Sukanda Djaya akan melakukan verifikasi dan pencatatan Nominal Lebih Bayar setelah pembayaran dan data transaksi diperiksa. Estimasi waktu pencatatan adalah:',
      },
      {
        type: 'list',
        items: [
          '1 x 24 jam untuk pembatalan seluruhnya; dan',
          '5 sampai 7 hari kerja untuk pembatalan sebagian.',
        ],
      },
      {
        type: 'paragraph',
        text: 'Estimasi tersebut dihitung sejak dokumen dan data pendukung dinyatakan lengkap dan pembayaran berhasil diverifikasi.',
      },
      {
        type: 'paragraph',
        text: 'Dalam kondisi tertentu, proses dapat memerlukan waktu lebih lama, misalnya apabila terdapat perbedaan data, kebutuhan rekonsiliasi tambahan, kendala sistem, atau kendala pada pihak bank.',
      },
    ],
  },
  {
    title: 'Tidak ada masa berlaku',
    blocks: [
      {
        type: 'paragraph',
        text: 'Nominal Lebih Bayar tidak memiliki masa berlaku.',
      },
      {
        type: 'paragraph',
        text: 'Selama akun Anda tetap aktif dan tidak ada koreksi atau pembatalan yang sah berdasarkan hasil pemeriksaan PT Sukanda Djaya, Nominal Lebih Bayar akan tetap tercatat dalam sistem Sukanda OneLink.',
      },
    ],
  },
  {
    title: 'Pemeriksaan dan keberatan',
    blocks: [
      {
        type: 'paragraph',
        text: 'Anda wajib memeriksa pencatatan dan penggunaan Nominal Lebih Bayar pada akun, invoice, atau dokumen transaksi yang tersedia di Sukanda OneLink.',
      },
      {
        type: 'paragraph',
        text: 'Apabila terdapat ketidaksesuaian, Anda wajib menyampaikan keberatan atau pengaduan kepada PT Sukanda Djaya paling lambat 14 (empat belas) hari kerja sejak:',
      },
      {
        type: 'list',
        items: [
          'tanggal pencatatan Nominal Lebih Bayar;',
          'tanggal penggunaan Nominal Lebih Bayar; atau',
          'tanggal Anda secara wajar seharusnya mengetahui adanya ketidaksesuaian tersebut.',
        ],
      },
      {
        type: 'paragraph',
        text: 'Keberatan yang diajukan melewati jangka waktu tersebut dapat tidak diproses, kecuali ditentukan lain oleh PT Sukanda Djaya atau diwajibkan oleh hukum yang berlaku.',
      },
    ],
  },
  {
    title: 'Hak PT Sukanda Djaya untuk melakukan koreksi',
    blocks: [
      {
        type: 'paragraph',
        text: 'PT Sukanda Djaya berhak melakukan koreksi, pengurangan, pembatalan, atau penyesuaian atas Nominal Lebih Bayar apabila ditemukan adanya:',
      },
      {
        type: 'list',
        items: [
          'kesalahan sistem;',
          'kesalahan input atau perhitungan;',
          'perubahan dasar transaksi;',
          'pembatalan atas dasar pencatatan sebelumnya;',
          'pembayaran yang ternyata tidak sah;',
          'indikasi fraud, manipulasi, atau penyalahgunaan; atau',
          'kewajiban hukum dan/atau permintaan dari instansi berwenang.',
        ],
      },
      {
        type: 'paragraph',
        text: 'Apabila dilakukan koreksi, perubahan tersebut akan dicatat pada sistem dan, sejauh memungkinkan, diinformasikan kepada pengguna melalui akun, dokumen transaksi, atau media resmi lainnya.',
      },
    ],
  },
  {
    title: 'Bukan layanan perbankan, kredit, atau pinjaman',
    blocks: [
      {
        type: 'paragraph',
        text: 'Nominal Lebih Bayar bukan:',
      },
      {
        type: 'list',
        items: [
          'layanan perbankan;',
          'kredit;',
          'pinjaman uang;',
          'fasilitas pembiayaan;',
          'simpanan dana; atau',
          'instrumen pembayaran umum.',
        ],
      },
      {
        type: 'paragraph',
        text: 'Nominal Lebih Bayar tidak memberikan bunga, imbal hasil, jasa, atau manfaat finansial lainnya kepada pengguna.',
      },
    ],
  },
  {
    title: 'Tanggung jawab pengguna',
    blocks: [
      {
        type: 'paragraph',
        text: 'Anda wajib memberikan data dan dokumen yang benar, lengkap, dan dapat dipertanggungjawabkan terkait transaksi yang menimbulkan Nominal Lebih Bayar.',
      },
      {
        type: 'paragraph',
        text: 'Anda wajib memastikan bahwa jika terdapat sisa tagihan setelah penggunaan Nominal Lebih Bayar, sisa tersebut dibayarkan sesuai metode pembayaran dan ketentuan yang berlaku.',
      },
    ],
  },
  {
    title: 'Batas tanggung jawab',
    blocks: [
      {
        type: 'paragraph',
        text: 'PT Sukanda Djaya berupaya mencatat dan mengelola Nominal Lebih Bayar secara akurat sesuai sistem dan prosedur internal yang berlaku.',
      },
      {
        type: 'paragraph',
        text: 'Namun, PT Sukanda Djaya tidak bertanggung jawab atas keterlambatan atau kegagalan pencatatan yang disebabkan oleh hal-hal di luar kendali wajar, termasuk namun tidak terbatas pada:',
      },
      {
        type: 'list',
        items: [
          'data yang tidak lengkap atau tidak akurat dari pengguna;',
          'bukti transfer yang tidak valid;',
          'gangguan sistem;',
          'kendala pada sistem perbankan;',
          'sengketa transaksi; atau',
          'keadaan kahar.',
        ],
      },
    ],
  },
  {
    title: 'Perubahan syarat dan ketentuan',
    blocks: [
      {
        type: 'paragraph',
        text: 'PT Sukanda Djaya dapat mengubah, memperbarui, atau menyesuaikan syarat dan ketentuan fitur Nominal Lebih Bayar dari waktu ke waktu.',
      },
      {
        type: 'paragraph',
        text: 'Setiap perubahan akan diinformasikan melalui Sukanda OneLink dan/atau media resmi PT Sukanda Djaya, dan akan berlaku sejak tanggal yang ditentukan dalam pemberitahuan tersebut.',
      },
    ],
  },
  {
    title: 'Hukum yang berlaku',
    blocks: [
      {
        type: 'paragraph',
        text: 'Syarat dan ketentuan ini tunduk pada dan ditafsirkan berdasarkan hukum Republik Indonesia.',
      },
    ],
  },
];
